import { render, staticRenderFns } from "./MentionStatsSummaryLinks.vue?vue&type=template&id=0d479a27&scoped=true"
import script from "./MentionStatsSummaryLinks.vue?vue&type=script&lang=js"
export * from "./MentionStatsSummaryLinks.vue?vue&type=script&lang=js"
import style0 from "./MentionStatsSummaryLinks.vue?vue&type=style&index=0&id=0d479a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d479a27",
  null
  
)

export default component.exports